















































import { Vue, Component } from "vue-property-decorator";
import { $layout } from "../services/LayoutService";

@Component
export default class AgAdminDrawer extends Vue {
  get drawer() {
    return $layout.drawer;
  }

  set drawer(val) {
    $layout.drawer = val;
  }
}
